// frontend/src/pages/admin/Inventory.js
import React, { useState } from 'react';
import { 
  FiPackage, 
  FiTrendingUp, 
  FiTrendingDown, 
  FiList
} from 'react-icons/fi';
import StockIn from './StockIn';
import StockOut from './StockOut';
import StockLevel from './StockLevel';
import TransactionHistory from './TransactionHistory';


const Inventory = () => {
  const [activeTab, setActiveTab] = useState('stock-level');

  const tabs = [
    { id: 'stock-level', label: 'Үлдэгдэл', icon: FiPackage, color: 'blue' },
    { id: 'stock-in', label: 'Орлого', icon: FiTrendingUp, color: 'green' },
    { id: 'stock-out', label: 'Зарлага', icon: FiTrendingDown, color: 'red' },
    { id: 'history', label: 'Түүх', icon: FiList, color: 'gray' }
  ];

  return (
    <div className="inventory-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Агуулахын удирдлага</h1>
        <p className="text-gray-600 mt-1">Барааны орлого, зарлага, үлдэгдэл, түүх</p>
      </div>

      <div className="card mb-6">
        <div className="flex space-x-1 overflow-x-auto">
          {tabs.map(tab => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center px-6 py-3 font-semibold whitespace-nowrap transition-all ${
                  isActive
                    ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <Icon className="mr-2" size={18} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        {activeTab === 'stock-level' && <StockLevel />}
        {activeTab === 'stock-in' && <StockIn />}
        {activeTab === 'stock-out' && <StockOut />}
        {activeTab === 'history' && <TransactionHistory />}
      </div>
    </div>
  );
};

export default Inventory;